/**
 * Routini API — Management
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const DayHealthStatus = {
    Ok: 'ok',
    Warning: 'warning',
    Error: 'error'
} as const;
export type DayHealthStatus = typeof DayHealthStatus[keyof typeof DayHealthStatus];

